import { signOut } from 'firebase/auth';
import { FirebaseProviderError } from './errors';

export default function signOutFactory(auth) {
  return signOut(auth)
    .then(() => {
      for (const key in window.localStorage) {
        if (key.indexOf('firebase:authUser') === 0) {
          window.localStorage.removeItem(key);
        }
      }
    })
    .catch(error => {
      throw new FirebaseProviderError(error);
    });
}
